import { SiteCreate } from '~/modules/sites';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';

export default function SiteCreatePage() {
  usePageTitle(t('menu.dashboard.settingsSites'));
  return <SiteCreate />;
}
